// BasicDatePicker.jsx or .tsx
import React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import classes from './DatePicker.module.css';

/**
 * `value` is passed in so the date survives a parent leaving and coming back — the picker used
 * to be uncontrolled, so a saved date was restored into the form but the field still looked
 * empty. `minDate` stops a day that has already gone being offered at all.
 */
export default function BasicDatePicker({ setHCCExpiryDate, error, helperText, value = null, minDate }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer sx={{ paddingTop: '0px' }} components={['DatePicker']}>
        <DatePicker
          value={value}
          minDate={minDate}
          onChange={setHCCExpiryDate}
          className={classes.mbiledtpckr}
          format="DD-MM-YYYY"
          slotProps={{
            textField: {
              error: error,
              helperText: helperText,
              size: 'small',
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
